import { CHART_ELEMENT_ID } from 'finviz-charts/app/constants/common'
import { Suspense } from 'react'
import ReactDOM from 'react-dom'
import ReactDOMClient from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { NotificationWrapper } from '../../main/components/notification'
import { SpecificChartFunctionality } from '../../main/constants'
import { ResizableChartLayoutWithGlobalState } from '../shared/components/ResizableChartLayoutWithGlobalState'
import { ready } from '../shared/ready'
import { parseInitData } from '../shared/utils'
import CryptoActionCreators from './actions/cryptoActionCreators'
import CryptoCharts from './charts'
import CryptoPerformance from './performance'
import CryptoQuotes from './quotes'
import { CryptoTileTicker, TileMap } from './types'

window['FinvizInitCrypto'] = function (tiles: TileMap) {
  CryptoActionCreators.initTiles(tiles)
  const rootEl = document.getElementById('crypto')
  const root = ReactDOMClient.createRoot(rootEl!)
  root.render(<CryptoQuotes />)

  setInterval(CryptoActionCreators.update, 30 * 1000)
}

window['FinvizInitCryptoPerformance'] = function (rows: Record<CryptoTileTicker, number>) {
  const rootEl = document.getElementById('futures')
  const root = ReactDOMClient.createRoot(rootEl!)
  root.render(<CryptoPerformance rows={rows} />)
}

window['FinvizInitCryptoCharts'] = function () {
  const cryptoEl = document.getElementById('crypto')
  const dataEl = document.getElementById('crypto-init-data')
  if (!cryptoEl || !dataEl) return

  try {
    const initData = parseInitData<TileMap>('crypto-init-data')
    CryptoActionCreators.update(initData)
  } catch {
    return
  }

  const root = ReactDOMClient.createRoot(cryptoEl)

  root.render(
    <BrowserRouter>
      <CryptoCharts />
    </BrowserRouter>
  )
}

ready(function () {
  const cryptoEl = document.getElementById('crypto')
  const chartEl = document.getElementById(CHART_ELEMENT_ID)
  const dataEl = document.getElementById('crypto-init-data')

  if (!cryptoEl || !chartEl || !dataEl || !window.globalChartConfig) return

  try {
    const initData = parseInitData<TileMap>('crypto-init-data')
    CryptoActionCreators.update(initData)
  } catch {
    return
  }

  const root = ReactDOMClient.createRoot(chartEl)

  root.render(
    <BrowserRouter>
      <NotificationWrapper>
        {ReactDOM.createPortal(<CryptoCharts />, cryptoEl)}
        <Suspense fallback={null}>
          <ResizableChartLayoutWithGlobalState specificChartFunctionality={SpecificChartFunctionality.cryptoPage} />
        </Suspense>
      </NotificationWrapper>
    </BrowserRouter>
  )
})
